// Aqua.jsx
import React,{useEffect} from 'react';
import CatsBanner from './CatsBanner';
import CatsPage from './Catspage';

const Cats = () => {
    useEffect(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, [])
    return (
        <div>
            <CatsBanner />
            <CatsPage/>
        </div>
    );
};

export default Cats;
